import { Fund, FundBalance, SourceFund, UserConversion } from '../../common/apiModels';

export const incompleteConversion: UserConversion = {
  weightedAverageFee: 0.01,
  secondPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 200, lastYear: 40, total: 250 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.01,
  },
  thirdPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 300, lastYear: 50, total: 450 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.01,
  },
};

export const lowFeesNoTulevaConversion: UserConversion = {
  weightedAverageFee: 0.0001,
  secondPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 200, lastYear: 40, total: 250 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0005,
  },
  thirdPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 300, lastYear: 50, total: 450 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0005,
  },
};

export const completeConversion: UserConversion = {
  weightedAverageFee: 0.0049,
  secondPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 560, lastYear: 100, total: 20600 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
  thirdPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 2500, lastYear: 1000, total: 37000 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
};

export const completeThirdPillarConversion: UserConversion = {
  weightedAverageFee: 0.004,
  secondPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 560, lastYear: 100, total: 20600 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.01,
  },
  thirdPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 2500, lastYear: 1000, total: 37000 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
};

export const thirdPillarNoPaymentThisYear: UserConversion = {
  weightedAverageFee: 0.004,
  secondPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 560, lastYear: 100, total: 20600 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
  thirdPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 0, lastYear: 1000, total: 37000 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
};

export const completeSecondPillarConversion: UserConversion = {
  weightedAverageFee: 0.004,
  secondPillar: {
    selectionComplete: true,
    selectionPartial: true,
    transfersComplete: true,
    transfersPartial: true,
    paymentComplete: true,
    pendingWithdrawal: false,
    contribution: { yearToDate: 2500, lastYear: 100, total: 37000 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.0049,
  },
  thirdPillar: {
    selectionComplete: false,
    selectionPartial: false,
    transfersComplete: false,
    transfersPartial: false,
    paymentComplete: false,
    pendingWithdrawal: false,
    contribution: { yearToDate: 560, lastYear: 100, total: 20600 },
    subtraction: { yearToDate: 0, lastYear: 0, total: 0 },
    weightedAverageFee: 0.01,
  },
};

export const activeSecondPillar: SourceFund = {
  activeFund: true,
  name: 'Tuleva II Samba Pensionifond',
  fundManager: { name: 'Tuleva' },
  pillar: 2,
  managementFeePercent: 0.003,
  isin: 'EE000123',
  price: 20000,
  unavailablePrice: 0,
  currency: 'EUR',
  ongoingChargesFigure: 0.0049,
  contributions: 500,
  subtractions: 0,
  profit: 500,
  units: 10000,
};

export const activeSecondPillarBondFund: SourceFund = {
  activeFund: true,
  name: 'Tuleva II Samba Võlakirjad',
  fundManager: { name: 'Tuleva' },
  pillar: 2,
  managementFeePercent: 0.003,
  isin: 'EE3600109443',
  price: 20000,
  unavailablePrice: 0,
  currency: 'EUR',
  ongoingChargesFigure: 0.0049,
  contributions: 500,
  subtractions: 0,
  profit: 500,
  units: 10000,
};

export const tulevaSecondPillarFund: Fund = {
  isin: 'EE123',
  name: 'Tuleva II Samba Fond',
  pillar: 2,
  managementFeeRate: 0.003,
  ongoingChargesFigure: 0.0049,
  fundManager: { name: 'Tuleva' },
  status: 'ACTIVE',
  inceptionDate: '2017-01-01',
  nav: 1,
};

export const activeThirdPillar: SourceFund = {
  activeFund: true,
  name: 'Tuleva III Samba Pensionifond',
  fundManager: { name: 'Tuleva' },
  pillar: 3,
  managementFeePercent: 0.003,
  isin: 'EE3600001707',
  price: 23,
  unavailablePrice: 0,
  currency: 'EUR',
  ongoingChargesFigure: 0.0049,
  contributions: 500,
  subtractions: 0,
  profit: 500,
  units: 23,
};

export const highFeeThirdPillar: SourceFund = {
  activeFund: true,
  name: 'LHV High Cost Fund III',
  fundManager: { name: 'LHV' },
  pillar: 3,
  managementFeePercent: 0.015,
  isin: 'EE1234567',
  price: 23,
  unavailablePrice: 0,
  currency: 'EUR',
  ongoingChargesFigure: 0.0156,
  contributions: 500,
  subtractions: 0,
  profit: 500,
  units: 23,
};

export const highFeeSecondPillar: SourceFund = {
  activeFund: true,
  name: 'LHV High Cost Fund II',
  fundManager: { name: 'LHV' },
  pillar: 2,
  managementFeePercent: 0.015,
  isin: 'EE432432',
  price: 20000,
  unavailablePrice: 0,
  currency: 'EUR',
  ongoingChargesFigure: 0.0156,
  contributions: 500,
  subtractions: 0,
  profit: 500,
  units: 20000,
};

export const additionalSavingsFund: FundBalance = {
  fund: {
    fundManager: {
      name: 'Tuleva',
    },
    isin: 'EE0000003283',
    name: 'Tuleva Täiendav Kogumisfond',
    managementFeeRate: 0.2,
    pillar: null,
    ongoingChargesFigure: 0.0049,
    status: 'ACTIVE',
    inceptionDate: '2025-10-01',
    nav: 1,
  },
  value: 0,
  unavailableValue: 0,
  currency: 'EUR',
  activeContributions: false,
  contributions: 0,
  subtractions: 0,
  profit: 0,
  units: 0,
};

export const activeSecondPillarBalance: FundBalance = {
  fund: {
    fundManager: { name: 'Swedbank' },
    isin: 'EE3600019758',
    name: 'Swedbank Pension Fund K60',
    managementFeeRate: 0.0083,
    pillar: 2,
    ongoingChargesFigure: 0.0065,
    status: 'ACTIVE',
    inceptionDate: '2017-01-01',
    nav: 1.46726,
  },
  value: 100000,
  unavailableValue: 0,
  currency: 'EUR',
  activeContributions: true,
  contributions: 112233.44,
  subtractions: 0,
  profit: -12233.44,
  units: 100000 / 1.46726,
};

export const tulevaThirdPillarBalance: FundBalance = {
  fund: {
    fundManager: { name: 'Tuleva' },
    isin: 'EE3600001707',
    name: 'Tuleva III Samba Pensionifond',
    managementFeeRate: 0.003,
    pillar: 3,
    ongoingChargesFigure: 0.0043,
    status: 'ACTIVE',
    inceptionDate: '2017-01-01',
    nav: 0.7813,
  },
  value: 5699.36,
  unavailableValue: 0,
  currency: 'EUR',
  activeContributions: true,
  contributions: 9876.54,
  subtractions: 0,
  profit: -1876.54,
  units: 5699.36 / 0.7813,
};
